export default __webpack_public_path__ + "static/media/earth.a08c82a6.jpg";